export const pfttPlusSevenCriteria: string = '1057'